export default {
  login: 'dangvannhang',
  id: 48082244,
  node_id: 'MDQ6VXNlcjQ4MDgyMjQ0',
  avatar_url: 'https://avatars.githubusercontent.com/u/48082244?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/dangvannhang',
  html_url: 'https://github.com/dangvannhang',
  followers_url: 'https://api.github.com/users/dangvannhang/followers',
  following_url:
    'https://api.github.com/users/dangvannhang/following{/other_user}',
  gists_url: 'https://api.github.com/users/dangvannhang/gists{/gist_id}',
  starred_url:
    'https://api.github.com/users/dangvannhang/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/dangvannhang/subscriptions',
  organizations_url: 'https://api.github.com/users/dangvannhang/orgs',
  repos_url: 'https://api.github.com/users/dangvannhang/repos',
  events_url: 'https://api.github.com/users/dangvannhang/events{/privacy}',
  received_events_url:
    'https://api.github.com/users/dangvannhang/received_events',
  type: 'User',
  site_admin: false,
  name: 'Đặng Văn Nhàng',
  company: 'VDC',
  blog: 'https://www.linkedin.com/in/nhangdang107/',
  location: 'Ho Chi Minh City, VietNam',
  email: 'dangvannhang107@gmail.com',
  hireable: null,
  bio: 'Hello everyone. I am a final-year IT student of PNV - Passerelles Numeriques Viet Nam. I am develop myself to become a Web FrontEnd developer.',
  twitter_username: null,
  public_repos: 22,
  public_gists: 0,
  followers: 2,
  following: 15,
  created_at: '2019-02-28T06:52:44Z',
  updated_at: '2021-08-05T00:58:43Z',
}
